import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ActivatedRoute } from '@angular/router';
import { OdaAtFirestore } from 'src/app/models/odaAtFirestore.model';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { environment } from 'src/environments/environment';
import { onSnapshot } from 'firebase/firestore';
import { UtilService } from 'src/app/services/util.service';
import { Menu } from 'primeng/menu';

import { ExcelService } from 'src/app/services/excelService.service';
import { FiltroPratica, PraticaFlowdy2_Firestore } from 'src/app/models/praticaFirestore.model';
import { StiliService } from 'src/app/services/stili.service';
import { UserService } from 'src/app/services/user.service';
import { PraticheService } from 'src/app/services/pratiche.service';
import { Location } from "@angular/common";
import { ListeService } from 'src/app/services/liste.service';
import { StoricoPraticaComponent } from '../../shared/storico/storico-pratica.component';
import { ImportLog_Firestore } from 'src/app/models/firestore/importLogFirestore.model';
import { Impresa } from 'src/app/models/impresa.model';
import { ImpreseService } from 'src/app/services/imprese.service';
import { v4 as uuidv4 } from 'uuid';
import { StoricoNotePraticaComponent } from '../../shared/note-pratica/note-pratica.component';
import { CategoriaVincolo, TipologiaVincolo } from 'src/app/models/categoriaVincolo.model';
import { DialogModificaVincolo } from '../../shared/modifica-vincolo/modifica_vincolo';

declare const CSVBoxImporter: any;
@Component({
    templateUrl: './ko.bando2.component.html',
    styleUrls: ['./ko.bando2.component.css'],
    providers: [DialogService, ConfirmationService],

})
export class PraticheKOBando2Component implements OnInit, OnDestroy {
    protected isLoadingResults:boolean = false;
    protected mostraPraticheCompletate:boolean = false;

    private importID: string; 

    protected showIniziaProgettazione:boolean = false;
    protected showGeneraDocumentazione:boolean = false;
    protected showDeliverConfirmation:boolean = false;
    protected showAnnullaConsegnaConfirmation:boolean = false;
    protected showEliminaFilePINGConfirmation:boolean = false;
    protected showEliminaFileSPEEDConfirmation:boolean = false;
    protected showConfermaPreventivo:boolean = false;
    protected showResettaPratica:boolean = false;
    protected showFase1Approvata:boolean = false;
    
    public isAdmin: boolean                     = false;
    public isSuperAdmin: boolean                = false;
    public isPresidioSF: boolean                = false;
    public isPresidioTIM: boolean               = false;
    public isDirigenteFirmaVerbali: boolean     = false;
    public isDirigenteFirmaPacchetti: boolean   = false;
    public isPM:boolean                         = false;
    public isContabile:boolean                  = false;
    public isImpresa:boolean                    = false;
    public isDemo:boolean                       = false;

    protected showRendiLavorabile:boolean = false;


    protected pratiche:PraticaFlowdy2_Firestore[] ;
    protected praticheFiltrate:PraticaFlowdy2_Firestore[] ;
    protected selectedPratica:PraticaFlowdy2_Firestore ;

    protected imprese:Impresa[]=[];
    
    @ViewChild("menuAzioni", { static: true }) azioniMenu: Menu;
    @ViewChild("menuAzioniTiered", { static: true }) azioniMenuTiered: Menu;

    protected menuAzioniItems!: MenuItem[];
    private _filtroPratiche!: FiltroPratica;

    get filtroPratiche(): FiltroPratica {
      return this._filtroPratiche;
    }
    
    set filtroPratiche(value: FiltroPratica) {
      this._filtroPratiche = value;
    }
    
    private collection_pratiche:string = environment.firebase.collection_pratiche;
    private collection_importLog:string = environment.firebase.collection_import_log;

    private ref: DynamicDialogRef;

    protected filterTabellaIsSet:boolean = false;
    protected filterIsSet:boolean = false;
    protected filtroInLavorazione:boolean = false;
    protected filtroLotto:String;
    protected filtroStatoInfratel:String;
    protected filtroOda:String;
    protected filtroDaPagare:boolean = false;
    protected filtroLottoPerFase:String;
    
    private csvbox_licenseKey_importaVincolateBando2:string    =environment.csvBox.secret_importaVincolateBando2;
    private csvbox_importer_vincolateBando2:any;
    

    protected filtroPratica:String;

    protected categorieVincolo:CategoriaVincolo[]=[];
    protected tipologieVincolo:TipologiaVincolo[]=[];

    @ViewChild("praticheDT", { static: true }) praticheDT: any;
    
    constructor(
        private logger: NGXLogger,
        public firestore: AngularFirestore,
        public utilService:UtilService,
        protected stiliService:StiliService,
        private userService:UserService,
        public dialogService: DialogService,
        private messageService: MessageService,
        private praticheService:PraticheService,
        private excelService:ExcelService,
        private activatedRoute: ActivatedRoute,
        private location: Location,
        protected listeService:ListeService,
        private aziendeService: ImpreseService,
        

      
    ) {
      this._filtroPratiche = {};
      this.setUserRole();
      this.loadImprese();
      this.loadCategorieVincolo();

    }
    loadImprese() {
      this.aziendeService.getByBando("2").subscribe((aziende) => {
        this.imprese = aziende;
      });
    }
    loadCategorieVincolo() {
      this.utilService.getTipologieVincolo().subscribe((categorieVincolo) => {
        this.categorieVincolo = categorieVincolo;
     });
    }

    

    ngOnDestroy(): void {
    }

    ngOnInit() {
      this.initCSVBox();
     // this.logger.info("[KO BANDO 2] ON ONIT");
      const urlParamInLavorazione   = this.activatedRoute.snapshot.paramMap.get('lavorazione');
      const urlParamLotto           = this.activatedRoute.snapshot.paramMap.get('lotto');
      const urlParamCodiceInfratel  = this.activatedRoute.snapshot.paramMap.get('stato');
      const urlParamOda             = this.activatedRoute.snapshot.paramMap.get('oda');
      
      this.activatedRoute.queryParamMap.subscribe((params) => {
        this.filtroDaPagare         = params.get('da-pagare') === 'true';
        this.filtroLottoPerFase     = params.get('lotto');
        this.filtroInLavorazione    = params.get('in-lavorazione')=== 'true';
        this.filtroPratica          = params.get('pratica');
      });
    
      if(this.filtroInLavorazione || this.filtroPratica){
        this.filterIsSet = true;
      }

     if(urlParamLotto){
        this.filtroLotto = urlParamLotto;
        this.filterIsSet = true;
      }else if(urlParamCodiceInfratel){
        this.filtroStatoInfratel = urlParamCodiceInfratel;
        this.filterIsSet = true;
      }else if(urlParamOda){
        this.filtroOda = urlParamOda;
        this.filterIsSet = true;
      }
       this.loadPratiche();
    }

    initCSVBox(){
      this.csvbox_importer_vincolateBando2 = new CSVBoxImporter(this.csvbox_licenseKey_importaVincolateBando2, {
      }, (result: boolean, data: any) => {
        if (result) {
          this.readImportLog();  
        } else {
          this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di import delle pratiche vincolate del bando 2', life:10000});
        }
      });
      
      
      
      this.csvbox_importer_vincolateBando2.setUser({
        user_id: "default123"
      });
    
     
      this.csvbox_importer_vincolateBando2.language="it";
      
    
    }

    readImportLog(){
      const collectionRef = this.firestore.collection(this.collection_importLog).ref;
      let queryErrori ;
      queryErrori = collectionRef.where("id", "==", this.importID);
      
      onSnapshot(queryErrori, (qs) => {
        this.isLoadingResults = false;
        qs.forEach((doc) => {
            let log: ImportLog_Firestore = doc.data() as ImportLog_Firestore;
            if(!log.errori || log.errori.length == 0){
              if(!log.warning || log.warning.length == 0){
                if(log.numeroRecordNonProcessati!=0){
                  if(log.numeroRecordNonProcessati==1){
                    this.messageService.add({severity:'success', summary:'', detail: 'Delle ' + log.numeroTotaleRecord+ ' pratiche presenti nel file ' + log.numeroRecordProcessati + ' sono state processate con successo mentre '+ log.numeroRecordNonProcessati+ ' non è stata processata', life:10000});
  
                  }else {
                    this.messageService.add({severity:'success', summary:'', detail: 'Delle ' + log.numeroTotaleRecord+ ' pratiche presenti nel file ' + log.numeroRecordProcessati + ' sono state processate con successo mentre '+ log.numeroRecordNonProcessati+ ' non sono state processate', life:10000});
  
                  }
                }else{
                  this.messageService.add({severity:'success', summary:'', detail: 'Tutte le ' + log.numeroTotaleRecord+ ' pratiche presenti nel file sono state processate con successo', life:10000});
  
                }
  
              }else{
                this.messageService.add({severity:'warn', summary:'Warning', detail:'Il caricamento degli esiti della consegna ad INFRATEL della FASE 1 si è concluso con '+ log.numeroRecordNonProcessati +' warning', life:10000});
              }
            }else{
              this.messageService.add({severity:'info', summary:'Errore', detail:'Il caricamento degli esiti della consegna ad INFRATEL della FASE si è concluso con '+ log.numeroRecordNonProcessati +' errori', life:10000});
            }
           
            
          });
      });
      
    }

    getTipoSedeAbbreviata(tipoSede:string):string{
      if(tipoSede.startsWith("M")){
        return "Mand. "+tipoSede.charAt(tipoSede.length-1);

      }else{
        return "Agg. "+tipoSede.charAt(tipoSede.length-1);
      }
    }

    
    
    async openCaricaAzioni( event: any, pratica:PraticaFlowdy2_Firestore ): Promise<void> {
      this.selectedPratica = pratica;
      this.loadAzioni(event, pratica);
      this.azioniMenuTiered.toggle(event);
    }

    visualizzaNote(pratica: PraticaFlowdy2_Firestore) {
      this.isLoadingResults = true;
      
      this.praticheService.getNote(pratica.id).subscribe(notePratica=>{
        this.isLoadingResults = false;
        this.ref = this.dialogService.open(StoricoNotePraticaComponent, {
          data: {
            pratica: pratica,
            note: notePratica,
          },
          header: "NOTE della pratica "+pratica.cui,
          width: "50%",
          height: "85%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
      });
    }

   
    loadAzioni(event:any, pratica:PraticaFlowdy2_Firestore){
      this.menuAzioniItems = [];
      if(!this.isImpresa){
        this.menuAzioniItems.push({
          label: "Note",
          icon: 'icona-note-presidio',
          style: {'font-size': '12px'},
          //items:itemsNote,
          command: () => this.visualizzaNote(pratica),
          },
         );
       }
     
        
        
      if(this.isImpresa){ //IMPRESA
        

      }else if(this.isPresidioSF || this.isAdmin || this.isSuperAdmin || this.isDemo){ //AZIONI SF & ADMIN
        if(pratica.vincoloTipologiaID != 4){
          this.menuAzioniItems.push(
            {
               label: "Rendi Lavorabile",
                icon: 'icona-rendi-lavorabile',
               style: {  'font-weight': 'bold', 'font-size': '11px'},
               command: () => this.rendiLavorabile(pratica),
               disabled: this.isDemo
             },
           );
           if(pratica.vincoloTipologiaID == 3){}
            
           
        }
        this.menuAzioniItems.push(
          {
             label: "Modifica Vincolo",
              icon: 'icona-trasforma-tipo-vincolo',
             style: {  'font-weight': 'bold', 'font-size': '11px'},
             command: () => this.modificaVincolo(pratica),
             disabled: this.isDemo
           },
         );
        
      

      }else if(this.isPresidioTIM){ //AZIONI PRESIDIO TIM 
       
        
      }
      
    }

    rendiLavorabile(pratica: PraticaFlowdy2_Firestore): void {
      this.showRendiLavorabile = true;
      this.selectedPratica = pratica;
    }

    modificaVincolo(pratica: PraticaFlowdy2_Firestore): void {
      this.ref = this.dialogService.open(DialogModificaVincolo, {
        data: {
          pratica: pratica,
         
        },
        header: "Modifica vincolo della pratica "+pratica.cui,
        width: "60%",
        height: "35%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((modificaCategoriaVincolo) => {
        if (modificaCategoriaVincolo && modificaCategoriaVincolo.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Categoria del vincolo della pratica '+pratica.cui+' modificata con successo!', life:3000});
          //this.loadPratiche();
        }
      });  
    }

   

    confermaRendiPraticaLavorabile(){
      this.isLoadingResults = true;
      this.praticheService.rendiLavorabilePraticaKO(this.selectedPratica.id).subscribe( {
        next: (v) => {
          this.isLoadingResults = false;
          this.messageService.add({severity:'success', summary:'', detail:'Pratica resa nuovamente lavorabile!', life:5000});
          this.showRendiLavorabile = false;
          this.selectedPratica = null;
          this.isLoadingResults = false;
          this.loadPratiche();
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di comunicazione lavorabilità della pratica'});
            this.isLoadingResults = false;
            this.showRendiLavorabile = false;
            this.selectedPratica = null;
            this.isLoadingResults = false;
        },
        complete: () => {
          
            
        }
      });
      
    }

    openStoricoPratica(pratica: PraticaFlowdy2_Firestore) {
      this.isLoadingResults = true;
      this.praticheService.getStorico(pratica.id).subscribe(storicoPratica=>{
       this.isLoadingResults = false;
         if(storicoPratica && storicoPratica.length > 0){
           this.logger.info(storicoPratica);
           this.ref = this.dialogService.open(StoricoPraticaComponent, {
             data: {
               pratica: pratica,
               storicoPratica: storicoPratica,
               fase:1
             },
             header: "Storico della FASE 1 della pratica "+pratica.cui,
             width: "50%",
             height: "85%",
             baseZIndex: 10000,
             closable: true,
             draggable: false,
           });
         }else{
           this.messageService.add({
             severity: "info",
             summary: "Attenzione!",
             detail: "La pratica non presenta STORICO",
           });
         }
     }); 
   }
    

    loadPratiche(){
        this.isLoadingResults = false;
        const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
        let query;
      if(this.isPresidioTIM){
        if(this.filterIsSet){
          if(this.filtroLotto){
            this.logger.info("[KO BANDO 2] PRESIDIO TIM LOADING KO BANDO 2 FILTRO PER LOTTO "+ this.filtroLotto);
            query= collectionRef.where("bando", "==", "BANDO 2")
            .where("lotto", "==", this.filtroLotto)
            .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }else if(this.filtroStatoInfratel){
            if(this.filtroLottoPerFase){
              this.logger.info("[KO BANDO 2] PRESIDIO TIM LOADING KO BANDO 2 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);
              query= collectionRef
              .where("bando", "==", "BANDO 2")
              .where("lotto", "==", this.filtroLottoPerFase)
              .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");

            }else {
              this.logger.info("[KO BANDO 2] PRESIDIO TIM LOADING KO BANDO 2 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

              query= collectionRef
              .where("bando", "==", "BANDO 2")
              .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");

            }
          }else  if(this.filtroInLavorazione){
            this.logger.info("[KO BANDO 2] PRESIDIO TIM LOADING KO BANDO 2 FILTRO PER IN LAVORAZIONE ");

            query= collectionRef
            .where("bando", "==", "BANDO 2")
            .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }else  if(this.filtroOda){
            this.logger.info("[KO BANDO 2] PRESIDIO TIM LOADING KO BANDO 2 FILTRO PER ODA "+ this.filtroOda);
            if(this.filtroDaPagare){
              query= collectionRef
              .where("bando", "==", "BANDO 2")
              .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");
            }else{
              query= collectionRef
              .where("bando", "==", "BANDO 2")
              .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");
            }
           
          }
          
        }else{
          this.logger.info("[KO BANDO 2] PRESIDIO TIM LOADING KO BANDO 2 SENZA FILTRI");

          if(!this.mostraPraticheCompletate){
             query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");
            
          }else{
            query= collectionRef
            .where("bando", "==", "BANDO 2")
            .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }
        }
      }else if(this.isImpresa){
        if(this.filterIsSet){
          if(this.filtroLotto){
            this.logger.info("[KO BANDO 2] LOADING PRATICHE PER AZIENDA KO FILTRO PER LOTTO "+ this.filtroLotto);
           query= collectionRef
            .where("bando", "==", "BANDO 2")
            .where("lotto", "==", this.filtroLotto)
            .where("idAzienda", "==", this.userService.getUser().azienda.id)
            .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }else if(this.filtroStatoInfratel){
            if(this.filtroLottoPerFase){
              this.logger.info("[KO BANDO 2] LOADING PRATICHE PER AZIENDA KO FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);

              query= collectionRef
              .where("bando", "==", "BANDO 2")
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
              .where("lotto", "==", this.filtroLottoPerFase)
              .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");

            }else {
              this.logger.info("[KO BANDO 2] LOADING PRATICHE PER AZIENDA KO FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

              query= collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase3", "==", this.filtroStatoInfratel)
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
              .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");

            }
          }else  if(this.filtroInLavorazione){
            this.logger.info("[KO BANDO 2] LOADING PRATICHE PER AZIENDA KO FILTRO PER IN LAVORAZIONE ");

            query= collectionRef
            .where("bando", "==", "BANDO 2")
            .where("idAzienda", "==", this.userService.getUser().azienda.id)
            .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }else  if(this.filtroOda){
            this.logger.info("[KO BANDO 2] LOADING PRATICHE PER AZIENDA KO FILTRO PER ODA "+ this.filtroOda);
            if(this.filtroDaPagare){
              query= collectionRef
              .where("bando", "==", "BANDO 2")
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
              .where("numeroOda", "==", Number(this.filtroOda))
              .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");
            }else{
              query= collectionRef
              .where("bando", "==", "BANDO 2")
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
              .where("numeroOda", "==", Number(this.filtroOda))
              .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");
            }
           
          }else if(this.filtroPratica){
            query= collectionRef
            .where("cui", "==", this.filtroPratica)
            .where("idAzienda", "==", this.userService.getUser().azienda.id);
          }
          
        }else{
          this.logger.info("[KO BANDO 2] LOADING PRATICHE PER AZIENDA KO SENZA FILTRI");

          if(!this.mostraPraticheCompletate){
             query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
              .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");
            
          }else{
            query= collectionRef
            .where("bando", "==", "BANDO 2")
            .where("idAzienda", "==", this.userService.getUser().azienda.id)
            .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }
        }
      }else if(this.isPresidioSF || this.isAdmin || this.isSuperAdmin || this.isDemo){
        if(this.filterIsSet){
          if(this.filtroLotto){
            this.logger.info("[KO BANDO 2] LOADING KO BANDO 2 FILTRO PER LOTTO "+ this.filtroLotto);
           query= collectionRef.where("bando", "==", "BANDO 2")
            .where("lotto", "==", this.filtroLotto)
          // .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }else if(this.filtroStatoInfratel){
            if(this.filtroLottoPerFase){
              this.logger.info("[KO BANDO 2] LOADING KO BANDO 2 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);

              query= collectionRef
                .where("bando", "==", "BANDO 2")
             
                .where("lotto", "==", this.filtroLottoPerFase)
             //   .where("sopralluogoOk", "==", false)
                .orderBy("dataUltimaModificaFase1");

            }else {
              this.logger.info("[KO BANDO 2] LOADING KO BANDO 2 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

              query= collectionRef
                .where("bando", "==", "BANDO 2")
            //    .where("sopralluogoOk", "==", false)
                .orderBy("dataUltimaModificaFase1");

            }
          }else if(this.filtroInLavorazione){
            this.logger.info("[KO BANDO 2] LOADING KO BANDO 2 FILTRO PER IN LAVORAZIONE ");
            query= collectionRef
              .where("bando", "==", "BANDO 2")
           //   .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }else  if(this.filtroOda){
            this.logger.info("[KO BANDO 2] LOADING KO BANDO 2 FILTRO PER ODA "+ this.filtroOda);
            if(this.filtroDaPagare){
              query= collectionRef
              .where("bando", "==", "BANDO 2")
              .where("numeroOda", "==", Number(this.filtroOda))
            //  .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
            }else{
              query= collectionRef
              .where("bando", "==", "BANDO 2")
              .where("numeroOda", "==", Number(this.filtroOda))
             // .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");
            }
           
          }else if(this.filtroPratica){
            //this.logger.info("[FASE 2 BANDO 1]] LOADING PRATICHE FASE 1 FILTRO PER PRATICA "+ this.filtroPratica );
            query= collectionRef
            .where("cui", "==", this.filtroPratica);
          }
          
        }else{
          this.logger.info("[KO BANDO 2] LOADING KO BANDO 2 SENZA FILTRI");

          if(!this.mostraPraticheCompletate){
             query = collectionRef
              .where("bando", "==", "BANDO 2")
           //  .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
             ;
            
          }else{
            query= collectionRef
            .where("bando", "==", "BANDO 2")
          //  .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }
        }
      }

        
        
        onSnapshot(query, (qs) => {
          //this.logger.info("[KO BANDO 2] KO BANDO 2 CARICATE "+ qs.docs.length);

          this.pratiche = [];
          this.praticheFiltrate = [];
          this.isLoadingResults = false;
          qs.forEach((doc) => {
            let pratica = doc.data() as PraticaFlowdy2_Firestore;
            if(pratica.sopralluogoOk===false || pratica.vincoloTipologiaID){
              this.pratiche.push(pratica);
              this.praticheFiltrate.push(pratica);
            }
            
            //this.logger.info("Categoria Vincolo: " + JSON.stringify(this._filtroPratiche.categoriaVincolo) + " Vs " + pratica.vincoloCategoriaCodice);

          });
          this.filtraPratiche(null);
        });
  
    }

    scaricaReportPraticheKO(){
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
      this.excelService.exportPraticheKOToExcel(this.pratiche, `pratiche_bando2_KO_${formattedDate}.xlsx`, this.isImpresa);
    }

    
    onMostraCompletatiChange(newValue: boolean): void {
      this.mostraPraticheCompletate = newValue
      this.loadPratiche();
    }

    checkInviataAdInfratel(pratica:PraticaFlowdy2_Firestore):boolean{
      if(pratica.codiceStatoInfratelFase3==='3-5' || pratica.codiceStatoInfratelFase3==='3-6'){
        return true;
      }
      return false;
    }

    importaPraticheVincolate(){
      this.importID = uuidv4();
      this.csvbox_importer_vincolateBando2.setUser({
        importID: this.importID,
      });
      this.csvbox_importer_vincolateBando2.openModal();
    }

    filtraPratiche(event: any){
     
      if(event && event.target){
        
        this.praticheDT.filterGlobal(event.target.value, 'contains');
      }else {
       
        if(this._filtroPratiche && Object.keys(this._filtroPratiche).length !== 0){
          //this.logger.info("Filtro Pratiche: " + JSON.stringify(this._filtroPratiche));
          this.filterTabellaIsSet = true;
          this.praticheFiltrate = this.pratiche.filter((pratica: PraticaFlowdy2_Firestore) => {
            //this.logger.info("Categoria Vincolo: " + JSON.stringify(this._filtroPratiche.categoriaVincolo) + " Vs " + pratica.vincoloCategoriaCodice);
            if(
              ((this._filtroPratiche.tipo?.length ?? 0 ) > 0  && (this._filtroPratiche.tipo.indexOf(pratica.tipoSede) == -1 || this._filtroPratiche.tipo.indexOf(pratica.tipoSedeEffettiva) == -1)) ||
              ((this._filtroPratiche.regione?.length ?? 0  > 0 ) &&  this._filtroPratiche.regione.indexOf(pratica.regione) == -1  )   ||
              ((this._filtroPratiche.impresa?.length ?? 0  > 0 ) &&  this._filtroPratiche.impresa.indexOf(pratica.idAzienda) == -1  ) ||
              ((this._filtroPratiche.causaKO?.length ?? 0  > 0 ) &&  this._filtroPratiche.causaKO.indexOf(pratica.causaSopralluogoKO) == -1  ) ||
              ((this._filtroPratiche.categoriaVincolo?.length ?? 0  > 0 ) &&  this._filtroPratiche.categoriaVincolo.indexOf(pratica.vincoloCategoriaCodice) == -1  ) ||
              ((this._filtroPratiche.tipoVincolo?.length ?? 0  > 0 ) &&  this._filtroPratiche.tipoVincolo.indexOf(pratica.vincoloTipologiaID) == -1  ) ||
              ((this._filtroPratiche.faseVincolo?.length ?? 0  > 0 ) &&  this._filtroPratiche.faseVincolo.indexOf(pratica.vincoloFase) == -1  )
            ){
              return false;
            }
            
            return true;

          });
        }else{
          this.praticheFiltrate = this.pratiche;
        }
      }
    }

    filtraPerStatoInfratel(statoInfratel:string){
      if(!this.filterTabellaIsSet){
        this.praticheDT.filterGlobal(statoInfratel, 'contains');
        this.filterTabellaIsSet = true;
      }else{
        this.praticheDT.clear();
        this.filterTabellaIsSet = false;
      }
    }

    filtraPerOda(numeroOda:number){
      
      if(!this.filterTabellaIsSet){
        if(
          (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) 
        ){
          this.praticheDT.filterGlobal(numeroOda, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.praticheDT.clear();
        if((!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) ){
            this.filterTabellaIsSet = false;
        }
      }
      
    }

    filtraPerBando(oda:OdaAtFirestore){
      if(!this.filterTabellaIsSet){
        this.praticheDT.filterGlobal(oda.bando, 'contains');
        this.filterTabellaIsSet = true;
      }else{
        this.praticheDT.clear();
        this.filterTabellaIsSet = false;
      }
      

      
    }
    filtraPerAzienda(azienda:String){
      if(!this.filterTabellaIsSet){
        if(
          (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) 
        ){
          this.praticheDT.filterGlobal(azienda, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.praticheDT.clear();
        if((!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) ){
            this.filterTabellaIsSet = false;
        }
      }
     }

    filtraPerLotto(lotto:string){
      if(!this.filterTabellaIsSet){
        if(
          (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) 
        ){
          this.praticheFiltrate = this.pratiche.filter((pratica: PraticaFlowdy2_Firestore) => {
            if(
              pratica.lotto === lotto

            ){
              return true;
            }
            
            return false;

          });
          //this.praticheDT.filterGlobal(lotto, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.praticheDT.clear();
        if((!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) ){
            this.filterTabellaIsSet = false;
        }
      }
    
      
    }
    removeFilter(){
      
      if(this.filtroLotto || this.filtroStatoInfratel || this.filtroInLavorazione || this.filtroOda || this.filtroLottoPerFase || this.filtroPratica){
        this.location.replaceState('/pratiche-bando1/fase-2');
        
        this.filterIsSet = false;
        this.filtroLotto = null;
        this.filtroStatoInfratel = null;
        this.filtroInLavorazione = null;
        this.filtroOda = null;
        this.filtroLottoPerFase = null;
        this.filtroPratica = null;
        this.loadPratiche();
      }else{
        if(this._filtroPratiche && 
          (this._filtroPratiche.tipo && this._filtroPratiche.tipo.length > 0) || 
          (this._filtroPratiche.regione && this._filtroPratiche.regione.length > 0 ) ||
          (this._filtroPratiche.impresa && this._filtroPratiche.impresa.length > 0 ) ||
          (this._filtroPratiche.causaKO && this._filtroPratiche.causaKO.length > 0 ) ||
          (this._filtroPratiche.vincoloKO && this._filtroPratiche.vincoloKO.length > 0 ) ||
          (this._filtroPratiche.categoriaVincolo && this._filtroPratiche.categoriaVincolo.length > 0 ) ||
          (this._filtroPratiche.tipoVincolo && this._filtroPratiche.tipoVincolo.length > 0 ) ||
          (this._filtroPratiche.faseVincolo && this._filtroPratiche.faseVincolo.length > 0 )
        ){
          this._filtroPratiche.tipo      = [];
          this._filtroPratiche.regione   = [];
          this._filtroPratiche.impresa   = [];
          this._filtroPratiche.causaKO   = [];
          this._filtroPratiche.vincoloKO = [];
          this._filtroPratiche.categoriaVincolo = [];
          this._filtroPratiche.tipoVincolo = [];
          this._filtroPratiche.faseVincolo = [];
        }
        this.filterTabellaIsSet = false;
        this.praticheFiltrate = this.pratiche;
        this.praticheDT.clear();
      }
     
     
    }

    mostraPratiche(oda:OdaAtFirestore, fase:string){

    }

    scaricaReportPratiche(){
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
      this.excelService.exportPraticheKOToExcel(this.pratiche, `pratiche_bando2_KO_${formattedDate}.xlsx`, this.isImpresa);
    }

    

    setUserRole(){
      if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "ADMIN"
      ) {
        this.isAdmin = true;
      } else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "SUPERADMIN"
      ) {
        this.isSuperAdmin = true;
      } else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "SMARTFIBER"
      ) {
        this.isPresidioSF = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "PRESIDIO"
      ) {
        this.isPresidioTIM = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
      ) {
        this.isImpresa = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_VERBALI"
      ) {
        this.isDirigenteFirmaVerbali = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_PACCHETTI"
      ) {
        this.isDirigenteFirmaPacchetti = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "PM"
      ) {
        this.isPM = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DEMO"
      ) {
        this.isDemo = true;
      }
    }
  
    getOptionLabel(item: any): string {
      return item.codice + ' - ' + item.label;
    }

    getTipoVincoloOptionLabel(item: any): string {
      return item.tipologiaVincolo.label;
    }
    getTipoVincoloOptionValue(item: any): string {
      return item.tipologiaVincolo.id;
    }

    getOptionValue(item: any): string {
      return item.codice;
    }
  }
